import '.am{height:100%;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.bv{border-radius:20px;}.ssr-plugin'
import '.iu{overflow-y:hidden;}.ssr-plugin'
import '.iv{flex:1 1 0;}.ssr-plugin'
import '.c0{overflow-y:scroll;}.ssr-plugin'
import { ComponentType, ReactNode, useState } from 'react'
import { IconProps } from '../Icon/index.js'
import { NewCMSAuthorizeFn, NewCMSRouteEvents, useNewCMS } from './index.js'
import { Stack } from '../Stack/index.js'
import { AppHeader } from '../AppHeader/index.js'
import { Text } from '../Text/index.js'
import { IconButton } from '../IconButton/index.js'
import { Style, styled } from 'inlines'
import { colors } from '../../tokens/colors.js'

export type NewCMSPageProps = {
  title: string
  icon?: IconProps['variant']
  counter?: number
  path?: string
  isAppHeaderHidden?: boolean
  appHeader?: ReactNode
  leadComponent?: ReactNode
  trailComponent?: ReactNode
  sidebar?: ReactNode
  component?: ComponentType<any>
  children?: ReactNode
  authorize?: NewCMSAuthorizeFn
  on?: NewCMSRouteEvents
}

export function NewCMSPage(_: NewCMSPageProps) {
  return null
}

export type PageLayoutProps = {
  page: Omit<
    NewCMSPageProps,
    'path' | 'component' | 'children' | 'authorize' | 'on'
  > & {
    group?: string
  }
  children: ReactNode
}

function PageBaseContainer({
  children,
  outsideStyle,
  insideStyle,
}: {
  children: ReactNode
  outsideStyle?: Style
  insideStyle?: Style
}) {
  return (
    <styled.div className="am f bv iu iv"
      style={{
        border: `1px solid ${colors.neutral10}`,
        background: `linear-gradient(0deg, ${colors.white5}) 0%, ${colors.white5}) 100%), ${colors.neutralInverted100}`,
        boxShadow: `0 8px 12px 0 ${colors.black10})`,
        ...outsideStyle,
      }}
    >
      <styled.div className="f am c0"
        style={{
          ...insideStyle,
        }}
      >
        {children}
      </styled.div>
    </styled.div>
  )
}

export function PageLayout({ page, children }: PageLayoutProps) {
  const [sidebarVisibility, setSidebarVisibility] = useState(true)

  return (
    <Stack
      direction="row"
      align="start"
      justify="start"
      gap={16}
      style={{ width: '100%', height: '100%' }}
    >
      <Stack direction="column" style={{ width: '100%', height: '100%' }}>
        {!page.isAppHeaderHidden &&
          (page.appHeader ? (
            page.appHeader
          ) : (
            <AppHeader variant="sub">
              <Stack
                direction="row"
                align="center"
                justify="start"
                style={{ width: '100%', height: 36 }}
              >
                <AppHeader.Left>
                  {page.leadComponent}

                  <Text variant="display-medium" color="neutral80">
                    {page.title}
                  </Text>

                  {page.sidebar && (
                    <IconButton
                      icon="show"
                      toggled={sidebarVisibility}
                      onClick={() => setSidebarVisibility(!sidebarVisibility)}
                    />
                  )}
                </AppHeader.Left>

                <AppHeader.Right>{page.trailComponent}</AppHeader.Right>
              </Stack>
            </AppHeader>
          ))}

        <PageBaseContainer>{children}</PageBaseContainer>
      </Stack>

      {sidebarVisibility && page.sidebar ? (
        <PageBaseContainer
          outsideStyle={{
            minWidth: 380,
          }}
          insideStyle={{
            overflowY: 'auto',
          }}
        >
          <AppHeader>
            <AppHeader.Right>
              <IconButton
                icon="close"
                onClick={() => setSidebarVisibility(false)}
              />
            </AppHeader.Right>
          </AppHeader>

          {page.sidebar}
        </PageBaseContainer>
      ) : null}
    </Stack>
  )
}
